import { State } from '../state.interface';
import * as Actions from '../actions';
import { assoc } from 'ramda';

export const setUseEditableImageReducer = (state: State, action: Actions.SetUseEditableImage) =>
  assoc('useEditableImage', action.payload.useEditableImage, state);
